<template>
	<section class="map_wrapper">
		<div class="copy" v-html="copy"></div>
		<div class="map">
			<IconMap class="map" />
			<span
				class="pin_wrapper"
				v-for="(point, n) in points"
				@click="selected = n"
				:style="{ top: `${point.top}%`, left: `${point.left}%` }"
				:key="`point_${n}`"
				@mouseenter="onPointerMouseEnter($event)"
				@mouseleave="onPointerMouseLeave($event)"
			>
				<IconPin class="pin" :class="{ selected: n === selected }" />
				<span class="name" :class="{ selected: n === selected }">{{
					point.name
				}}</span>
			</span>
		</div>
		<div class="data" v-if="currentPoint">
			<span class="data_title">{{ currentPoint.name }}</span>
			<select v-model="selected">
				<option v-for="(point, n) in points" :value="n" :key="`sel_${n}`">{{
					point.name
				}}</option>
			</select>
			<div class="data_more">
				<h2>{{ currentPoint.title }}</h2>
				<div class="block_wrapper">
					<div class="block" v-html="currentPoint.address"></div>
					<div class="block var_extra_data">
						<span
							@mouseenter="onPointerMouseEnter($event, 'text')"
							@mouseleave="onPointerMouseLeave($event, 'text')"
						>
							<a :href="`tel:${filteredPhone}`">{{ currentPoint.phone }}</a>
						</span>
						<span
							@mouseenter="onPointerMouseEnter($event, 'text')"
							@mouseleave="onPointerMouseLeave($event, 'text')"
						>
							<a :href="`mailto:${currentPoint.email}`">
								<IconEmail />{{ email }}</a
							>
						</span>
						<span
							@mouseenter="onPointerMouseEnter($event, 'text')"
							@mouseleave="onPointerMouseLeave($event, 'text')"
						>
							<a :href="currentPoint.url" target="_blank">
								<IconLinkOut />{{ website }}</a
							>
						</span>
					</div>
				</div>
				<span ref="shadow" class="shadow"></span>
			</div>
		</div>
		<!-- <ModuleHover ref="hover" /> -->
	</section>
</template>

<script>
import { mapState } from "vuex";
import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import IconMap from "@/components/icons/IconMap";
import IconPin from "@/components/icons/IconPin";
import IconEmail from "@/components/icons/IconEmail";
import IconLinkOut from "@/components/icons/IconLinkOut";
import pointerHove from "@/mixins/pointerHover";

gsap.registerPlugin(ScrollToPlugin);

export default {
	mixins: [pointerHove],
	props: {
		copy: String,
		website: String,
		email: String,
	},
	components: {
		IconMap,
		IconPin,
		IconEmail,
		IconLinkOut,
		// ModuleHover
	},
	data() {
		return {
			selected: 0,
		};
	},
	computed: {
		...mapState({
			points: (state) => state.pin.all,
		}),
		currentPoint() {
			return this.points.length ? this.points[this.selected] : false;
		},
		filteredPhone() {
			if (this.currentPoint && this.currentPoint.phone) {
				return this.currentPoint.phone.replace(
					/tel:|Tel:|tel|Tel| |-|tel.|Tel./g,
					""
				);
			}

			return "";
		},
	},
	mounted() {
		if (!this.points.length) {
			this.$store.dispatch("pin/getAll");
		}
	},
	methods: {
		onMouseEnter(ev) {
			const el = ev.currentTarget;
			const data = el.getBoundingClientRect();
			const scaleX = (data.width / 65) * 1.2;
			const scaleY = (data.height / 62) * 1.2;
			const x = data.left - 10;

			gsap.to(this.$refs.hover.$el, {
				x: x,
				y: data.top,
				duration: 0.3,
				scaleX: scaleX,
				scaleY: scaleY,
				transformOrigin: "0% 50%",
			});
		},
		onMouseLeave() {
			gsap.to(this.$refs.hover.$el, {
				scale: 0,
				duration: 0.1,
				transformOrigin: "50% 50%",
			});
		},
	},
	filters: {
		removeHttp(value) {
			if (!value) return value;

			return value.replace(/https:\/\/|http:\/\//g, "");
		},
	},
	watch: {
		selected() {
			let top = this.$el.offsetTop;
			let correction = -50;
			// $sizeBreakpointS: 420px;
			// $sizeBreakpointM: 421px;
			// $sizeBreakpointL: 801px;
			// $sizeBreakpointXL: 1201px;
			if (window.innerWidth > 421) {
				correction = 40;
			}
			// const elData = this.$el.getBoundingClientRect();
			// console.log(elData);
			console.log(top);
			gsap.to(window, { duration: 0.7, scrollTo: { y: top + correction } });
			gsap
				.timeline()
				.fromTo(
					this.$refs.shadow,
					{ opacity: 0, scale: 0.3 },
					{ opacity: 1, scale: 1, duration: 0.3 }
				)
				.to(this.$refs.shadow, { opacity: 0, scale: 1.2, duration: 0.3 });
		},
	},
};
</script>

<style lang="scss" scoped>
.map_wrapper {
	@include moduleSpacing;
	width: 100% !important;
	margin-left: 0 !important;

	@include mq($from: xl) {
		display: flex;
		flex-wrap: wrap;
	}

	.copy {
		@include fontCopy;
		@include textFormat;

		@include mq($from: m) {
			@include gridColumn(m, 15, 1, false, true);
		}

		@include mq($from: xl) {
			@include gridColumn(xl, 13, 2, false, true);
		}
	}

	.map {
		margin-top: 20px;
		position: relative;
		z-index: 3;

		@include mq($from: xl) {
			@include gridColumn(xl, 17, 0, false, false);
		}

		.pin_wrapper {
			position: absolute;
			z-index: 4;
			display: block;
			cursor: pointer;
		}

		svg.map {
			width: 100%;
			height: auto;
			z-index: 3;
		}

		svg.pin {
			width: 10px;
			height: 13px;

			transition: transform 0.3s;
			transform-origin: center bottom;

			@include mq($from: m) {
				width: 13px;
				height: 18px;
			}

			@include mq($from: xl) {
				width: 14px;
				height: 20px;
			}

			&::v-deep path {
				transition: fill 0.3s;
				fill: $colorRed1 !important;
			}
		}

		svg.pin.selected {
			transform: scale(1, 1.159);

			&::v-deep path {
				fill: #fff !important;
			}
		}

		span.name {
			position: absolute;
			top: 100%;
			left: 50%;
			font-weight: 500;
			font-size: 12px;
			text-decoration: underline;
			color: $colorRed1;
			transition: color 0.3s;
			font-family: $fontRubik;
			display: none;

			@include mq($from: m) {
				display: block;
			}

			@include mq($from: xl) {
				display: block;
			}

			&.selected {
				color: #fff;
				text-decoration: none;
			}
		}
	}

	.data {
		position: relative;
		display: block;
		border: 2px solid $colorGraphite;
		border-radius: 2px;
		margin-top: 25px;

		@include mq($from: m) {
			border: none;
		}

		@include mq($from: xl) {
			@include gridColumn(xl, 6, 1, false, true);
		}

		select {
			@include fontCopy;
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			padding: 8px 25px;
			opacity: 0;

			@include mq($from: m) {
				display: none;
			}
		}

		&_title {
			@include fontCopy;
			display: block;
			font-weight: 500;
			padding: 8px 25px;
			border-bottom: 2px solid $colorGraphite;
			position: relative;

			@include mq($from: m) {
				display: none;
			}

			&:after {
				content: "";
				display: block;
				width: 12px;
				height: 12px;
				border-radius: 2px;
				border-left: 2px solid $colorGraphite;
				border-bottom: 2px solid $colorGraphite;

				position: absolute;
				right: 20px;
				top: calc(50% - 9px);
				transform: rotate(-45deg);
			}
		}

		&_more {
			padding: 25px;

			@include mq($from: m) {
				padding: 25px 4.5%;
				display: flex;
			}

			@include mq($from: xl) {
				display: block;
				padding: 0;
			}

			h2 {
				@include fontLeadIn;
				// letter-spacing: -1;

				@include mq($from: m) {
					width: 51%;
				}

				@include mq($from: xl) {
					width: 100%;
				}
			}

			.block_wrapper {
				@include mq($from: m, $to: xl) {
					border-left: 1px solid rgba(0, 0, 0, 0.31);
					padding-left: 25px;
				}
			}

			.block {
				@include fontCopy;
				@include textFormat;
				margin-top: 15px;

				@include mq($from: m, $to: xl) {
					&:first-child {
						margin-top: 0;

						&::v-deep p:first-child {
							margin-top: 0;
						}
					}
				}

				&::v-deep * {
					font-weight: 500 !important;
				}

				a,
				span {
					display: inline-block;
					color: inherit;
				}

				// a:hover {
				// 	color: $colorRed1;
				// }

				&.var_extra_data {
					span {
						display: block;
						margin-top: 2px;
					}

					svg {
						vertical-align: middle;
						margin-right: 5px;
					}
				}
			}

			.shadow {
				position: absolute;
				top: -160px;
				left: -140px;
				width: 350px;
				height: 350px;
				background: $colorRed1;
				z-index: -1;
				border-radius: 60% 70% 65% 70% / 75% 65% 85% 75%;
				transform: scale(0);
				transform-origin: center;
				opacity: 0;

				@include mq($from: m) {
					left: auto;
					top: -70px;
					right: 20px;
				}

				@include mq($from: l) {
					left: auto;
					top: -70px;
					right: 100px;
				}

				@include mq($from: xl) {
					left: auto;
					top: -50px;
					right: 100px;
				}

				@include mq($from: 2250px) {
					left: auto;
					top: -50px;
					right: 200px;
				}
			}
		}
	}
}
</style>
